import React, { FC } from 'react';
import styled from 'styled-components';

type Props = {
  isVisible: boolean;
  filterLen: number;
  onMoreFilters: () => void;
};
export const MoreFilters: FC<Props> = ({
  isVisible,
  filterLen,
  onMoreFilters,
}) => {
  const moreFiltersText = getMoreFiltersText(filterLen);

  if (!isVisible) {
    return null;
  }
  return <Wrapper onClick={onMoreFilters}>{moreFiltersText}</Wrapper>;
};
export const Wrapper = styled.span`
  font-size: 1.3rem;
  color: #798794;
  margin-right: auto;
  align-self: center;
  user-select: none;
  text-decoration: underline;

  &:hover {
    cursor: pointer;
    color: black;
  }

  &:active {
    cursor: default;
    opacity: 1;
  }
`;

function getMoreFiltersText(filterLen: number) {
  return filterLen > 1 ? `Extra filters (${filterLen})` : `Extra filters`;
}
